module.exports = __webpack_public_path__ + "static/PersonalityTests-97e1202357d8e072ac787df39f1c1d7e.png";